import { CellCoordsObj, CellRangeObj, CellSelection } from '../../../../common/table/TableTypes';

type CellRangeSize = CellCoordsObj;

/**
 * Converts a cell selection tuple into a range object with matching endpoints.
 */
export const getCellRangeFromSelection = (cellSelection: CellSelection): CellRangeObj => {
    const [startRow, startCol, endRow, endCol] = cellSelection;

    return {
        from: { row: startRow, col: startCol },
        to: { row: endRow, col: endCol },
    };
};

/**
 * Converts a range object into the tuple format used for table selections.
 */
export const getCellSelectionFromRange = (cellRange: CellRangeObj): CellSelection => [
    cellRange.from.row,
    cellRange.from.col,
    cellRange.to.row,
    cellRange.to.col,
];

/**
 * Creates an inclusive cell range from a start position and row/column counts.
 */
export const getCellRangeFromStartAndSize = ({
    start,
    size,
}: {
    start: CellCoordsObj;
    size: CellRangeSize;
}): CellRangeObj => ({
    from: start,
    to: {
        row: start.row + size.row - 1,
        col: start.col + size.col - 1,
    },
});
